import React from 'react';
import { Button, Icon } from '@chakra-ui/react';
import { FaFileCsv } from "react-icons/fa6";
import { RiFileExcel2Fill } from "react-icons/ri";
import { LuLoaderCircle } from "react-icons/lu";
import { exportDataApi } from '../../../api/apiLists/getExportDataApi';
import { getExportFileApi } from '../../../api/apiLists/getExportFile';
import '../../../App.css';
import { triggerFileDownload } from '../../../utils/downloadFile';
import { useDispatch, useSelector } from 'react-redux';
import { showAlert } from '../../../store/alertSlice';
import ActionMenu from '../table/Action';

const ExportButton = ({
  source,           // array of objects to export
  filters = {},   // { fromDate, toDate, ... } used to generate filename
  fileType = 'text/csv',
  buttonLabel = 'Export',
  buttonProps = {},
  disabled,
}) => {
  const [loader, setLoader] = React.useState(false);
  const dispatch = useDispatch();
  const idToken = useSelector((state) => state.auth.user?.tokens?.idToken) || '';
  const companyId = useSelector((state) => state.auth.user?.companyId) || '';
  
  const handleExport = async (fileType) => {
    if( disabled || loader) return;
    setLoader(true);
    try {
      const authHeaders = {
          Authorization: idToken ? `Bearer ${idToken}` : '',
      };
      const data = await exportDataApi('ADD', source, filters, fileType, authHeaders, companyId);
      if(data.status && data.data.exportId) {
        await new Promise(resolve => setTimeout(resolve, 2000));
        const file = await getExportFileApi('GET', data.data.exportId, authHeaders);
        if (file.status && file.data.downloadURL) {
          triggerFileDownload(file.data.downloadURL);
        } else {
          // Check if polling timed out (no data found for applied filters)
          if (file.errMsg === "Polling timed out") {
            dispatch(showAlert({
              type: 'info',
              message: 'No data found! Please adjust your filters and try again.'
            }));
          } else {
            console.error('Export failed:', file.errMsg || 'Unknown error');
            dispatch(showAlert({
              type: 'error',
              message: 'Export failed. Please try again.'
            }));
          }
        }
      } else {
        console.error('Download URL not found or export failed');
      }
    } catch (error) {
      console.error('Error during export:', error);
    } finally {
      setLoader(false);
    }
  };

  const exportActions=[
    { name: "as CSV", icon: <FaFileCsv />, function: () => handleExport("csv") },
    { name: "as Excel", icon: <RiFileExcel2Fill />, function: () => handleExport("xlsx") }
  ];
  return (
    (
      loader ? 
      <Button fontWeight="500" disabled={true} bg={"blue.500"} color="white">
        <Icon
          as={LuLoaderCircle}
          boxSize={4}
          mr={2}
          className={loader ? 'rotating-icon' : ''}
        />
        Downloading..
      </Button> :
      <ActionMenu actions={exportActions} name={"Export"} iconKey={"EXPORT"} color={"blue.500"} textColor="white" />
    )
  );
};

export default ExportButton;
